module.exports = __webpack_public_path__ + "img/m_bgBox_bg.066a9250.png";